import { render } from "./NotFound.vue?vue&type=template&id=dc1adda8"
const script = {}
script.render = render

export default script